import { SAFE_VALUES } from '@/base/constants/SafeValues'
import { createStorageManager } from './storage-manager-factory'

export const LOCAL_STORAGE_KEYS = Object.freeze({
  isTranslate: 'isTranslate',
  sideMenuCollapsed: 'sideMenuCollapsed',
  trackId: 'trackId',
  trackIds: 'trackIds',
  activeApp: 'activeApp',
  countryCode: 'countryCode',
  countryCodes: 'countryCodes',
  countryFilter: 'countryFilter',
  date: 'date',
  startDate: 'startDate',
  endDate: 'endDate',
  compareStartDate: 'compareStartDate',
  compareEndDate: 'compareEndDate',
  selectedDate: 'selectedDate',
  month: 'month',
  year: 'year',
  publisherId: 'publisherId',
  developerName: 'developerName',
  competitorGroupId: 'competitorGroupId',
  platformId: 'platformId',
  name: 'name',
  store: 'store',
  device: 'device',
  categoryId: 'categoryId',
  categories: 'categories',
  categoryType: 'categoryType',
  ageId: 'ageId',
  sortType: 'sortType',
  chartScale: 'chartScale',
  chartDataMode: 'chartDataMode',
  languageCode: 'languageCode',
  keyword: 'keyword',
  keywords: 'keywords',
  keywordGroupId: 'keywordGroupId',
  cppFilter: 'cppFilter',
  appUpdateTypes: 'appUpdateTypes',
  progression: 'progression',
  rankType: 'rankType',
  videoFilter: 'videoFilter',
  adNetwork: 'adNetwork',
  appTaxonomies: 'appTaxonomies',
  gameTaxonomies: 'gameTaxonomies',
  loginCsrf: 'loginCsrf',
  recentlySearchedApps: 'recentlySearchedApps',
  recentlySearchedPublishers: 'recentlySearchedPublishers',
  pkceConfig: 'pkceConfig',
  exploreSectionStatus: 'exploreSectionStatus',
  keywordTrackingTableState: 'keywordTrackingTableState',
  asoReportTableState: 'asoReportTableState',
  initialReferrer: 'initialReferrer',
  slotCountries: 'slotCountries',
  slotCountriesRadio: 'slotCountriesRadio',
  planDowngradePopupShown: 'planDowngradePopupShown',
  loomVideoPlayerActions: 'loomVideoPlayerActions',

  // AD Intel Params
  listOfAdvertisers: 'listOfAdvertisers',
  listOfAdPublishers: 'listOfAdPublishers',
  mediaId: 'mediaId',
  collectionId: 'collectionId',
  detail: 'detail',
})

const localStorageManager = createStorageManager(localStorage, LOCAL_STORAGE_KEYS, {
  prefix: 'ma_',
  placeholderData: {
    isTranslate: false,
    sideMenuCollapsed: true,
    countryCode: SAFE_VALUES.countryCode,
    countryCodes: SAFE_VALUES.countryCodes,
    languageCode: SAFE_VALUES.languageCode,
    device: SAFE_VALUES.device,
    loginCsrf: {},
    recentlySearchedApps: [],
    recentlySearchedPublishers: [],
    slotCountries: {},
    slotCountriesRadio: {},
    loomVideoPlayerActions: {},
    exploreSectionStatus: {
      categoryRanking: true,
      reviewRating: true,
      appUpdateTimeline: true,
      creativeExplorer: true,
      searchAdsIntelligence: true,
      brandProtection: true,
      appVisibility: true,
      marketIntelligence: true,
      adIntelligence: true,
      metadata: true,
      appDetails: true,
      featuringAnalysis: true,
    },
    planDowngradePopupShown: false,
  },
})

export { localStorageManager }
